import React, { useState } from 'react';
import { Box, Card, Tab, Tabs } from '@mui/material';

export interface TicketTabConfig {
  id: string;
  label: string;
  content: React.ReactNode;
}

type TicketTabsProps = {
  tabs: TicketTabConfig[];
};

const TicketTabs: React.FC<TicketTabsProps> = ({ tabs }) => {
  const [currentTab, setCurrentTab] = useState(tabs[0]?.id ?? '');

  if (!tabs.length) {
    return null;
  }

  return (
    <Card sx={{ p: 0, mb: 3 }}>
      <Tabs
        value={currentTab}
        onChange={(_, value) => setCurrentTab(value)}
        variant="scrollable"
        scrollButtons="auto"
        sx={{ px: 2, pt: 2, borderBottom: (theme) => `1px solid ${theme.palette.divider}` }}
      >
        {tabs.map((tab) => (
          <Tab key={tab.id} label={tab.label} value={tab.id} />
        ))}
      </Tabs>
      <Box sx={{ p: 3 }}>
        {tabs.map((tab) => (
          <Box key={tab.id} role="tabpanel" hidden={currentTab !== tab.id}>
            {currentTab === tab.id && tab.content}
          </Box>
        ))}
      </Box>
    </Card>
  );
};

export default TicketTabs;
